import React from "react";
import Box from "../Box";
import styled from "styled-components";
import SectionHeaderAndContent from "../SectionHeaderAndContent";
import {
  TravellerDetailsGrid,
  TravellerDetailsGridItem,
} from "../../pages/ConfirmBookingStatus/ConfirmRequestGridLayout";
import dayjs from "dayjs";
import { getDestination } from "../../helper";
import { Colors } from "../../config";

const column = [
  {
    key: "departureDate",
    label: "Departure Date",
  },
  {
    key: "departureTime",
    label: "Preferred Time",
  },
  {
    key: "from",
    label: "From",
  },
  {
    key: "to",
    label: "Destination",
  },
  {
    key: "returnDate",
    label: "Return Date",
  },
  {
    key: "returnTime",
    label: "Return Preferred Time",
  },
  {
    key: "perferAirline",
    label: "Airlines", //need to revisit to check for multiple airlines
  },
];

const TravelDetail = ({ detailsData, isBusinessTrip }) => {
  const allColumns = isBusinessTrip
    ? [...column, { key: "flightType", label: "Flight Type" }]
    : [...column];
  return (
    <DetailsContainer>
      {isBusinessTrip ? (
        <>
          {detailsData &&
            detailsData.travelDetails.map((td) => (
              <Box boxPadding="0.0625rem 2rem 1rem">
                <TravellerDetailsGrid>
                  {allColumns.map((eachCol, i) => {
                    return (
                      <TravellerDetailsGridItem key={i}>
                        <SectionHeaderAndContent
                          heading={eachCol.label}
                          content={
                            eachCol.key === "perferAirline"
                              ? td[eachCol.key]?.length > 0
                                ? td[eachCol.key]?.join(",")
                                : "-"
                              : ["returnDate", "departureDate"].includes(
                                    eachCol.key,
                                  )
                                ? td[eachCol.key]
                                  ? dayjs(td[eachCol.key]).format(
                                      "MMM DD, YYYY",
                                    )
                                  : "-"
                                : ["from", "to"].includes(eachCol.key)
                                  ? getDestination(td[eachCol.key])
                                  : td[eachCol.key] || "-"
                          }
                          headerFontWeight="500"
                          contentFontSize="0.875rem"
                          contentFontWeight="500"
                        />
                      </TravellerDetailsGridItem>
                    );
                  })}
                </TravellerDetailsGrid>
                <div id={3}>
                  <BoxWrapper>
                    <Box>
                      <CommentHeader>Selected Services</CommentHeader>
                      <BRGrid>
                        {td?.businessTripReqs?.map((btr) => (
                          <div style={{ flex: 1, paddingRight: "2rem" }}>
                            <Header>{btr?.name}</Header>
                            <Value>
                              {btr?.selected
                                ? btr.selected
                                : btr?.selectedArray?.length > 0
                                  ? btr.selectedArray.join(", ")
                                  : btr?.amount
                                    ? `${btr.currency} ${btr.amount}`
                                    : btr?.isChecked
                                      ? "Yes"
                                      : "No"}
                            </Value>
                          </div>
                        ))}
                      </BRGrid>
                    </Box>
                  </BoxWrapper>
                </div>
                {/* <div id={3}>
                  <BoxWrapper>
                    <Box>
                      <CommentHeader>Other Details</CommentHeader>
                      <BRGrid>
                        <div style={{ flex: 2, paddingRight: "2rem" }}>
                          <Header>Company</Header>
                          <Value>{`${td?.costBorneBy?.companyName} (${td?.costBorneBy?.companyCode})`}</Value>
                        </div>
                        <div style={{ flex: 1, paddingRight: "2rem" }}>
                          <Header>Cost Center</Header>
                          <Value>
                            {td?.costCenter ? td?.costCenter : "NA"}
                          </Value>
                        </div>
                        <div style={{ flex: 1, paddingRight: "2rem" }}>
                          <Header>Project ID</Header>
                          <Value>{td?.projectId ? td?.projectId : "NA"}</Value>
                        </div>
                        <div style={{ flex: 2, paddingRight: "2rem" }}>
                          <Header>Special Request</Header>
                          <Value>{detailsData?.bookingComments || "NA"}</Value>
                        </div>
                      </BRGrid>
                    </Box>
                  </BoxWrapper>
                </div> */}
              </Box>
            ))}
        </>
      ) : (
        <>
          {detailsData && (
            <Box boxPadding="0.0625rem 2rem 1rem">
              <TravellerDetailsGrid>
                {allColumns.map((eachCol, i) => {
                  return (
                    <TravellerDetailsGridItem key={i}>
                      <SectionHeaderAndContent
                        heading={eachCol.label}
                        content={detailsData[eachCol.key]}
                        headerFontWeight="500"
                        contentFontSize="0.875rem"
                        contentFontWeight="500"
                      />
                    </TravellerDetailsGridItem>
                  );
                })}
              </TravellerDetailsGrid>
            </Box>
          )}
        </>
      )}
    </DetailsContainer>
  );
};

export default TravelDetail;

const DetailsContainer = styled.div`
  // margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const BRGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  & > div {
    width: calc(25% - 16px);
  }

  @media (max-width: 1024px) {
    & > div {
      width: calc(33.33% - 16px);
    }
  }

  @media (max-width: 768px) {
    & > div {
      width: calc(50% - 16px);
    }
  }

  @media (max-width: 480px) {
    & > div {
      width: 100%;
    }
  }
`;

const Header = styled.div`
  color: rgb(142, 142, 161);
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
`;

const Value = styled.div`
  color: rgb(34, 36, 44);
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
`;

const BoxWrapper = styled.div`
  margin-top: 1.5rem;
`;
const CommentHeader = styled.div`
  color: ${Colors.brandTwo};
  font-size: 0.875rem;
  margin-bottom: 1rem;
`;
